/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  OpenAPIv3SecuritySchemeSummary,
  OpenAPIv3SecuritySchemeSummary$inboundSchema,
} from "./openapiv3securityschemesummary.js";

export type OpenAPIv3DocumentSnapshot = {
  /**
   * The document-level security requirement.
   */
  defaultSecurity: string;
  /**
   * The security schemes tools can use.
   */
  securitySchemes: Array<OpenAPIv3SecuritySchemeSummary>;
  /**
   * The default server URL tools call.
   */
  serverUrl?: string | undefined;
  /**
   * The number of operations that cannot be turned into tools.
   */
  skippedOperationCount: number;
  /**
   * The number of tools the document produces.
   */
  toolCount: number;
};

/** @internal */
export const OpenAPIv3DocumentSnapshot$inboundSchema: z.ZodMiniType<
  OpenAPIv3DocumentSnapshot,
  unknown
> = z.pipe(
  z.object({
    default_security: z.string(),
    security_schemes: z.array(OpenAPIv3SecuritySchemeSummary$inboundSchema),
    server_url: z.optional(z.string()),
    skipped_operation_count: z.int(),
    tool_count: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "default_security": "defaultSecurity",
      "security_schemes": "securitySchemes",
      "server_url": "serverUrl",
      "skipped_operation_count": "skippedOperationCount",
      "tool_count": "toolCount",
    });
  }),
);

export function openAPIv3DocumentSnapshotFromJSON(
  jsonString: string,
): SafeParseResult<OpenAPIv3DocumentSnapshot, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OpenAPIv3DocumentSnapshot$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OpenAPIv3DocumentSnapshot' from JSON`,
  );
}
